import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { navigate } from "gatsby";
import { Link } from "gatsby";

// styles
import * as styles from "./WhatTwinDo.module.css";

const WhatTwinDo = ({ onCtaClick }) => {
  // Handle card click
  const handleCardClick = (path, cardName) => {
    if (onCtaClick) {
      onCtaClick(cardName);
    }
    navigate(path);
  };

  return (
    <section className={styles.whatTwinDoWrapper}>
      <div className={`container`}>
        {/* Section Header */}
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>What Twin can do</h2>
          <p className={styles.sectionSubtitle}>
            Twin Health provides a personalized metabolic Care Plan designed to
            maximize health outcomes. It helps members improve metabolism,
            achieve diabetes remission, stabilize PMOS symptoms, and optimize
            daily energy levels.
          </p>
        </div>

        {/* Cards Grid */}
        <div className={styles.cardsGrid}>
          {/* Members Card */}
          <div className={`${styles.card} ${styles.membersCard}`}>
            <div
              className={styles.cardImageWrapper}
              onClick={() => handleCardClick("/about-program/", "Members Card")}
              onKeyDown={e =>
                e.key === "Enter" &&
                handleCardClick("/about-program/", "Members Card")
              }
              role="button"
              tabIndex={0}
            >
              <StaticImage
                src="../../../images/home/home-members.png"
                alt="Twin Health for Members"
                placeholder="blurred"
                className={styles.cardImage}
                loading="lazy"
              />
            </div>
            <div className={styles.cardContent}>
              <div className={styles.cardTextWrapper}>
                <h3 className={styles.cardTitle}>For Members</h3>
                <p className={styles.cardSubtitle}>
                  Offer our members a sustainable, long-term solution for
                  metabolic health.
                </p>
              </div>
              <Link
                to="/about-program/"
                className={styles.arrowLink}
                onClick={() => onCtaClick && onCtaClick("Members Card Arrow")}
                aria-label="Learn more about Members"
              >
                <StaticImage
                  src="../../../images/icons/white-right-arrow.png"
                  alt="Arrow"
                  placeholder="blurred"
                  loading="lazy"
                />
              </Link>
            </div>
          </div>

          {/* Doctors Card */}
          <div className={`${styles.card} ${styles.doctorsCard}`}>
            <div
              className={styles.cardImageWrapper}
              onClick={() => handleCardClick("/for-doctors/", "Doctors Card")}
              onKeyDown={e =>
                e.key === "Enter" &&
                handleCardClick("/for-doctors/", "Doctors Card")
              }
              role="button"
              tabIndex={0}
            >
              <StaticImage
                src="../../../images/home/home-doctors.png"
                alt="Twin Health for Doctors"
                placeholder="blurred"
                className={styles.cardImage}
                loading="lazy"
              />
            </div>
            <div className={styles.cardContent}>
              <div className={styles.cardTextWrapper}>
                <h3 className={styles.cardTitle}>For Doctors</h3>
                <p className={styles.cardSubtitle}>
                  Enhance Patient Outcomes with Real time patient health
                  tracking
                </p>
              </div>
              <Link
                to="/for-doctors/"
                className={styles.arrowLink}
                onClick={() => onCtaClick && onCtaClick("Doctors Card Arrow")}
                aria-label="Learn more about Doctors"
              >
                <StaticImage
                  src="../../../images/icons/white-right-arrow.png"
                  alt="Arrow"
                  placeholder="blurred"
                  loading="lazy"
                />
              </Link>
            </div>
          </div>

          {/* Employers Card */}
          <div className={`${styles.card} ${styles.employersCard}`}>
            <div
              className={styles.cardImageWrapper}
              onClick={() =>
                handleCardClick("/for-employers/", "Employers Card")
              }
              onKeyDown={e =>
                e.key === "Enter" &&
                handleCardClick("/for-employers/", "Employers Card")
              }
              role="button"
              tabIndex={0}
            >
              <StaticImage
                src="../../../images/home/home-employers.png"
                alt="Twin Health for Employers"
                placeholder="blurred"
                className={styles.cardImage}
                loading="lazy"
              />
            </div>
            <div className={styles.cardContent}>
              <div className={styles.cardTextWrapper}>
                <h3 className={styles.cardTitle}>For Employers</h3>
                <p className={styles.cardTitle2}>(Corporate care)</p>
                <p className={styles.cardSubtitle}>
                  Transform the health of your workforce with AI Digital Twin.
                </p>
              </div>
              <Link
                to="/for-employers/"
                className={styles.arrowLink}
                onClick={() => onCtaClick && onCtaClick("Employers Card Arrow")}
                aria-label="Learn more about Employers"
              >
                <StaticImage
                  src="../../../images/icons/white-right-arrow.png"
                  alt="Arrow"
                  placeholder="blurred"
                  loading="lazy"
                />
              </Link>
            </div>
          </div>

          {/* Insurers Card */}
          <div className={`${styles.card} ${styles.insurersCard}`}>
            <div
              className={styles.cardImageWrapper}
              onClick={() => handleCardClick("/for-insurers/", "Insurers Card")}
              onKeyDown={e =>
                e.key === "Enter" &&
                handleCardClick("/for-insurers/", "Insurers Card")
              }
              role="button"
              tabIndex={0}
            >
              <StaticImage
                src="../../../images/home/home-insurer.png"
                alt="Twin Health for Insurers"
                placeholder="blurred"
                className={styles.cardImage}
                loading="lazy"
              />
            </div>
            <div className={styles.cardContent}>
              <div className={styles.cardTextWrapper}>
                <h3 className={styles.cardTitle}>For Insurance Companies</h3>
                <p className={styles.cardSubtitle}>
                  Reduce claim ratio with better NPS
                </p>
              </div>
              <Link
                to="/for-insurers/"
                className={styles.arrowLink}
                onClick={() => onCtaClick && onCtaClick("Insurers Card Arrow")}
                aria-label="Learn more about Insurers"
              >
                <StaticImage
                  src="../../../images/icons/white-right-arrow.png"
                  alt="Arrow"
                  placeholder="blurred"
                  loading="lazy"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatTwinDo;
